import { api } from '../../../shared/lib/axios';

/** Acessos externos do cliente (change `acesso-gestor-cliente`). */

export interface AcessoExterno {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  active: boolean;
  createdAt: string;
  pendingFirstAccess: boolean;
  lastSessionAt: string | null;
}

export interface ResultadoAcesso {
  welcomeEmailSent?: boolean;
  passwordSetupLink?: { url: string; expiresInHours: number } | null;
}

export interface NovoAcessoPayload {
  contactId?: string;
  name?: string;
  email?: string;
  cpf: string;
  phone?: string;
}

function unwrap<T>(body: unknown): T {
  const { version: _v, _links: _l, ...rest } = (body ?? {}) as Record<string, unknown>;
  return rest as T;
}

export async function listarAcessosExternos(clientId: string): Promise<AcessoExterno[]> {
  const { data } = await api.get(`/clients/${clientId}/external-users`);
  const list = (data as { data?: unknown }).data;
  return Array.isArray(list) ? (list as AcessoExterno[]) : [];
}

export async function criarAcessoExterno(clientId: string, payload: NovoAcessoPayload): Promise<AcessoExterno & ResultadoAcesso> {
  const { data } = await api.post(`/clients/${clientId}/external-users`, payload);
  return unwrap(data);
}

export async function situacaoAcessoExterno(clientId: string, userId: string, active: boolean): Promise<AcessoExterno> {
  const { data } = await api.patch(`/clients/${clientId}/external-users/${userId}/active`, { active });
  return unwrap(data);
}

export async function reenviarAcessoExterno(clientId: string, userId: string): Promise<ResultadoAcesso> {
  const { data } = await api.post(`/clients/${clientId}/external-users/${userId}/resend-access`);
  return unwrap(data);
}

export interface PortalCliente {
  user: { id: string; name: string; email: string };
  client: { id: string; code: string; corporateName: string; tradeName: string | null };
}

export async function portalDoCliente(): Promise<PortalCliente> {
  const { data } = await api.get('/client-portal/me');
  return unwrap(data);
}
